define('controllers/myreport/myreport-app-statistics.ctrl',['app'], function (app) {
    app.controller('AppStatisticsReport', ['$scope', '$q', 'OpenApp', 'OpenOther', 'auiDialog', 'AppSurveyReport', 'reportUtil',
        function ($scope, $q, OpenApp, OpenOther, auiDialog, AppSurveyReport, reportUtil) {
            /* 1. 局部变量声明 */
            var appList = [];
            var queryAPPFlag = false;
            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                tabType: 'install',
                installMagicType: 'line',
                activationMagicType: 'line',
                activeMagicType: 'line',
                activateMagicType: 'bar',
                regionnalMagicType: 'bar',
                terminalTypeMagicType: 'bar',
                versionMagicType: 'line',
                portraitMagicType1: 'bar',
                portraitMagicType2: 'bar',
                portraitMagicType3: 'bar',
                portraitMagicType4: 'bar',
                queryInstall: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 4, 8, 9],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 4,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: '2M',
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryInstallList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    installContentAll: -1,
                    installContentSum: 1,
                    installContentDay: 1,
                    installContentNew: -1,
                    installContentUpdate: -1,
                    installContentChange: installContentChange,
                    onload: init
                },
                queryActivation: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 4, 8, 9],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 4,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: '2M',
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryActivationList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    activationContentAll: 1,
                    activationContentSum: 1,
                    activationContentNew: 1,
                    activationContentChange: activationContentChange
                },
                queryActive: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 4, 8, 9],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 4,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: '2M',
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryActiveList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                },
                queryActivate: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 8, 9],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: '2M',
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    regionType: 8,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryActivateList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                },
                queryRegionnal: {
                    // 传递哪些筛选条件，哪些筛选条件就展示。全集如下
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 9, 8],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 8,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    timeQuantum: '2M',
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryDownloadList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    RegionnalSortType: 1,            //地域分析 选择排序】1【枚举】1:安装量2:激活量
                    RegionnalTop: 10,                 //地域分析 选择地域】10【枚举】10:top102:top20
                    province: "",
                    watchContentAll: 1,
                    watchContentInstall: 11,            //地域分析|机型分析】查看内容
                    watchContentActivation: 12        //地域分析|机型分析】查看内容
                },
                queryTerminalType: {
                    // 传递哪些筛选条件，哪些筛选条件就展示。全集如下
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 9, 8],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 8,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: '2M',
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    startTime: AUI.DateUtil.calDateByType(8).startDate,           //【开始时间】【默认值】过去一个月
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryDownloadList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    topTerminalTop: 10,            //机型分析 选择机型】1【枚举】10：top1020:top20
                    topTerminalSortType: 'increasedDay',                 //机型分析 选择排序】increasedDay【枚举】increasedDay:安装量activationDay:激活量
                    os: [],                                               //机型分析  选择os列表
                    watchContentAll: 1,
                    watchContentInstall: 11,            //地域分析|机型分析】查看内容
                    watchContentActivation: 12         //地域分析|机型分析】查看内容
                },
                queryVersion: {
                    // 传递哪些筛选条件，哪些筛选条件就展示。全集如下
                    appId: '',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 4, 9, 8],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 4,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: '2M',
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    startTime: AUI.DateUtil.calDateByType(4).startDate,           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryDownloadList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    versionContent: 1,                  //机型分析  查看内容
                    versionTop: 5,                       //机型分析 选择排序】5:top5 10:top10 0:自定义
                    versionVer: '',                    //机型分析 自定义的值
                    versionOs: []            //机型分析】选择os系统
                },
                queryPortrait: {
                    // 传递哪些筛选条件，哪些筛选条件就展示。全集如下
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('statistics', 4),
                    regionShow: [0, 9, 8],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 8,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    timeQuantum: '2M',
                    todayCheck: 'Y',          //【是否校验开始时间不能等于今天】
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    queryMethod: queryDownloadList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadDownloadList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮，
                    watchContentPortraitAll: 1,           //画像分析 查看内容
                    watchContentPortraitInstall: 11,      //画像分析 查看内容
                    watchContentPortraitActivation: 12,   //画像分析 查看内容
                    watchContentPeopleAll: 1,             //画像分析 选择任务属性
                    watchContentPeopleSex: 11,        //画像分析 选择任务属性
                    watchContentPeopleAge: 12    //画像分析 选择任务属性

                },
                paginationInstall: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "没有数据",
                    pagesLength: 5,
                    onChange: pageChangeInstall
                },
                paginationActivation: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeActivation
                },
                paginationActive: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeActive
                },
                paginationActivate: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeActivate
                },
                paginationRegionnal: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeRegionalDownload
                },
                paginationTerminalType: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeTerminalTypeDownload
                },
                paginationVersion: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeVersionDownload
                },
                paginationPortrait: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangePortraitDownload
                },
                installList: null,
                activationList: null,
                activeList: null,
                activateList: null,
                regionnalList: null,
                terminalTypeList: null,
                versionList: null,
                portraitList: null,
                installCharts: {
                    id: "myreport_statistics_install",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                activationCharts: {
                    id: "myreport_statistics_activation",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                activeCharts: {
                    id: "myreport_statistics_active",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                activateCharts: {
                    id: "myreport_statistics_activate",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                downloadRegionnalCharts: {
                    id: "myreport_statistics_regionnal",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                downloadTerminalTypeCharts: {
                    id: "myreport_statistics_terminaltype",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                downloadVersionCharts: {
                    id: "myreport_statistics_version",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                downloadPortraitInstallSexCharts: {
                    id: "myreport_statistics_portrait_install_sex",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                downloadPortraitActivationSexCharts: {
                    id: "myreport_statistics_portrait_activation_sex",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                }, downloadPortraitInstallAgeCharts: {
                    id: "myreport_statistics_portrait_install_age",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                }, downloadPortraitActivationAgeCharts: {
                    id: "myreport_statistics_portrait_activation_age",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                }

            };
            Model.variableOfScope = 'variable of scope';
            /* 3. $scope函数挂载 */
            $scope.changeTabType = changeTabType;
            $scope.queryDownloadList = queryDownloadList;
            $scope.downloadDownloadList = downloadDownloadList;

            /* 4. 初始化函数声明与执行 */
            function init() {
                changeTabType();
            }

            /* 5. 函数声明 */
            function changeTabType(type) {
                if (type) {
                    Model.tabType = type;
                }
                switch (Model.tabType) {
                    case 'install':
                        if (Model.installList == null) {
                            //首页老是无法展示图表，延迟查询
                            setTimeout(function () {
                                queryInstallList()
                            }, 200);
                        }
                        break;
                    case 'activation':
                        if (Model.activationList == null) {
                            queryActivationList();
                        }
                        break;
                    case 'active':
                        if (Model.activeList == null) {
                            queryActiveList();
                        }
                        break;
                    case 'activate':
                        if (Model.activateList == null) {
                            queryActivateList();
                        }
                        break;
                    case 'regionnal':

                        if (Model.regionnalList == null) {
                            queryDownloadList();
                        }
                        break;
                    case 'terminalType':

                        if (Model.terminalTypeList == null) {
                            queryDownloadList();
                        }
                        break;
                    case 'version':

                        if (Model.versionList == null) {
                            Model.queryVersion.firstEnter = true;
                            queryDownloadList();
                        }
                        break;
                    case 'portrait':

                        if (Model.portraitList == null) {
                            queryDownloadList();
                        }
                        break;
                }
            }

            function initAppList() {
                var defer = $q.defer();
                if (queryAPPFlag) {
                    var time = window.setInterval(function () {
                        if (!queryAPPFlag) {
                            defer.resolve(appList);
                            window.clearInterval(time);
                        }
                    }, 10);
                } else {
                    if (appList && appList.length > 0) {
                        defer.resolve(appList);
                    } else {
                        queryAPPFlag = true;
                        $scope.$parent.initAppSel().then(function (resp) {
                            appList = resp;
                            queryAPPFlag = false;
                            defer.resolve(appList);
                        });
                    }
                }
                return defer.promise;
            }

            /* 5. 函数声明 */
            function queryDownloadList() {
                switch (Model.tabType) {
                    case 'regionnal':

                        var startTime = Model.queryRegionnal.startTime;
                        var endTime = Model.queryRegionnal.endTime;

                        if (Model.queryRegionnal.watchContentInstall != 11 && Model.queryRegionnal.watchContentActivation != 12) {
                            auiDialog.fail('请至少选择一个查看内容。');
                            return;
                        }
                        var topId = Model.queryRegionnal.RegionnalTop;
                        var type = Model.queryRegionnal.RegionnalSortType;
                        var province = Model.queryRegionnal.province;
                        province = $.trim(province);
                        var reg = /^[\u4e00-\u9fa5]+$/;
                        if (province && !reg.test(province)) {
                            auiDialog.fail('请输入正确的地域。');
                            return;
                        }
                        if (province && reg.test(province)) {
                            topId = 10;
                        }
                        getReportRegionaltypeData(Model.queryRegionnal.appId, startTime,
                            endTime, 99, 1, topId, type, province);


                        break;

                    case  'terminalType':

                        var startTime = Model.queryTerminalType.startTime;
                        if (angular.isDate(startTime)) {
                            startTime = AUI.DateUtil.date2Str(startTime);
                        }
                        var endTime = Model.queryTerminalType.endTime;

                        if (Model.queryTerminalType.watchContentInstall != 11 && Model.queryTerminalType.watchContentActivation != 12) {
                            auiDialog.fail('请至少选择一个查看内容。');
                            return;
                        }
                        var topTerminalType = Model.queryTerminalType.topTerminalTop;
                        var sortType = Model.queryTerminalType.topTerminalSortType;
                        var os = Model.queryTerminalType.os;

                        if (os && os instanceof Array && os.length > 0) {
                            var osStr = '';
                            os.forEach(function (v) {
                                osStr += v.os + ',';
                            });
                            os = osStr.substring(0, osStr.length - 1);
                        } else {
                            os = '0';
                        }
                        getReportTerminaltypeData(Model.queryTerminalType.appId, startTime, endTime, 99, 1, topTerminalType, sortType, os);
                        break;
                    case 'version':
                        var defer = $q.defer();
                        var appId = Model.queryVersion.appId;
                        if (appId == -1) {
                            if (Model.queryVersion.firstEnter) {
                                //但第一次进来的时候防止当前用户没有应用导致页面异常
                                Model.downloadVersionCharts.options = null;
                                Model.versionList = [];
                                Model.paginationVersion.totalCount = 0;
                                pageChangeVersionDownload();
                            }
                            auiDialog.fail('请选择单个应用进行查询。');
                            return;
                        }
                        getReportVersionData(appId, 0, 1, getEchartConfig, function () {
                            var appId = Model.queryVersion.appId;
                            var paramsTemp = getParamsVersion();
                            if (!paramsTemp) {
                                return;
                            }
                            var pageSize = 99;
                            var pageNum = 1;
                            var params = {};
                            paramsTemp.pageSize = pageSize;
                            paramsTemp.pageNum = pageNum;
                            if (parseInt(appId, 10) === -1) {
                                params = paramsTemp;
                                params.appId = '-1';
                            }
                            else {
                                params = paramsTemp;
                                params.appId = appId;
                            }
                            OpenOther.getReportVersionDayBI(params).then(function (resp) {
                                if (parseInt(resp.returnCode, 10) === 100 || parseInt(resp.returnCode, 10) === 200) {
                                    Model.versionList = resp.reportAppVersionTableList;
                                    Model.paginationVersion.totalCount = resp.total;
                                } else {
                                    Model.versionList = [];
                                    Model.paginationVersion.totalCount = 0;
                                }
                                Model.paginationVersion.currentPage = 1;
                                Model.paginationVersion.itemsPerPage = Model.paginationVersion.itemsPerPageBackUp;
                                pageChangeVersionDownload();
                                defer.resolve();
                            }, function () {
                                defer.resolve();
                            }).catch(function () {
                                Model.versionList = [];
                                Model.paginationVersion.totalCount = 0;
                                pageChangeVersionDownload();
                                defer.resolve();
                            })
                        }, function () {
                            defer.resolve();
                        });

                        return defer.promise;
                        break;

                    case 'portrait':

                        var appId = Model.queryPortrait.appId;
                        var startTime = Model.queryPortrait.startTime;
                        var endTime = Model.queryPortrait.endTime;

                        if (Model.queryPortrait.watchContentPortraitInstall != 11 && Model.queryPortrait.watchContentPortraitActivation != 12) {
                            auiDialog.fail('请至少选择一个查看内容。');
                            return;
                        }
                        if (Model.queryPortrait.watchContentPeopleSex != 11 && Model.queryPortrait.watchContentPeopleAge != 12) {
                            auiDialog.fail('请至少选择一个人物属性。');
                            return;
                        }
                        getReportPortraitData(appId, startTime, endTime, 0, 1, getEchartConfig);
                        break;
                }


            }

            function getReportPortraitData(appId, startTime, endTime, pageSize, pageNum, callBack) {
                endTime = AUI.DateUtil.getEndTime(endTime);
                var params;
                if (parseInt(appId, 10) !== -1) {
                    params = {
                        appId: appId,
                        startTime: startTime,
                        endTime: endTime,
                        pageSize: pageSize,
                        pageNum: pageNum
                    };
                }
                else {
                    params = {
                        appId: -1,
                        startTime: startTime,
                        endTime: endTime,
                        pageSize: pageSize,
                        pageNum: pageNum
                    };
                }
                OpenOther.getReportAppPortraitBI(params).then(function (resp) {


                    // 用户访问记录需求
                    //当返回参数为正常的是的
                    if (parseInt(resp.retCode, 10) === 200 || parseInt(resp.retCode, 10) === 100) {
                        Model.portraitList = resp.reportAppPortraitListTable;
                        Model.paginationPortrait.totalCount = resp.total;
                    } else {
                        Model.portraitList = [];
                        Model.paginationPortrait.totalCount = 0;
                    }
                    callBack();
                    Model.paginationPortrait.currentPage = 1;
                    Model.paginationPortrait.itemsPerPage = Model.paginationPortrait.itemsPerPageBackUp;
                    pageChangePortraitDownload();

                }).catch(function () {
                    callBack();
                    Model.portraitList = [];
                    Model.paginationPortrait.totalCount = 0;
                })

            };

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangePortraitDownload() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.portraitList, Model.paginationPortrait, true));
                Model.downloadListForPortraitShow = result.listForShow;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeRegionalDownload() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.regionnalList, Model.paginationRegionnal, true));
                Model.downloadListForRegionalShow = result.listForShow;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeTerminalTypeDownload() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.terminalTypeList, Model.paginationTerminalType, true));
                Model.downloadListForTerminalTypeShow = result.listForShow;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeVersionDownload() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.versionList, Model.paginationVersion, true));
                Model.downloadListForVersionShow = result.listForShow;
            }

            function getParamsVersion() {
                var params;
                var startTime = Model.queryVersion.startTime;
                if (angular.isDate(startTime)) {
                    startTime = AUI.DateUtil.date2Str(startTime);
                }
                var endTime = Model.queryVersion.endTime;
                endTime = AUI.DateUtil.getEndTime(endTime);
                var content = Model.queryVersion.versionContent;
                var top = Model.queryVersion.versionTop;
                var os = Model.queryVersion.versionOs;
                var version = '';
                if (top == 0) {
                    version = Model.queryVersion.versionVer;
                    top = 1;
                }

                if (os instanceof Array && os.length > 0) {
                    var osStr = '';
                    os.forEach(function (v) {
                        osStr += v.os + ',';
                    });
                    os = osStr.substring(0, osStr.length - 1);
                } else {
                    os = '0';
                }

                params = {
                    startTime: startTime,
                    endTime: endTime,
                    os: os,
                    top: top,
                    version: version,
                    content: content
                }
                return params;
            };
            function getReportVersionData(appId, pageSize, pageNum, callBack, callBackForList) {
                var paramsTemp = getParamsVersion();
                paramsTemp.pageSize = pageSize;
                paramsTemp.pageNum = pageNum;
                params = paramsTemp;
                params.appId = (parseInt(appId, 10) === -1) ? '-1' : appId;
                OpenOther.getReportVersionDayBI(params).then(function (resp) {
                    Model.versionDate = {};
                    // 用户访问记录需求
                    //返回参数为100的时候为空参数，但是也是成功的应该记录
                    if (parseInt(resp.returnCode, 10) === 100 || parseInt(resp.returnCode, 10) === 200) {
                        if (Model.queryVersion.firstEnter) {
                            Model.queryVersion.firstEnter = false;
                        }
                        Model.versionDate = resp;
                    }
                    callBack();
                    callBackForList();

                }).catch(function () {
                    callBack();
                    callBackForList();
                })


            };

            function getReportTerminaltypeData(appId, startTime, endTime, pageSize, pageNum, topTerminalType, sortType, os) {
                endTime = AUI.DateUtil.getEndTime(endTime);
                var params = {
                    appId: appId,
                    startTime: startTime,
                    endTime: endTime,
                    pageSize: pageSize,
                    pageNum: pageNum,
                    topTerminalType: topTerminalType,
                    sortType: sortType,
                    os: os
                };
                OpenOther.getReportTerminalTypeBI(params).then(function (resp) {
                    // 用户访问记录需求
                    //当返回参数为正常的是的
                    if (parseInt(resp.returnCode, 10) === 200 || parseInt(resp.returnCode, 10) === 100) {
                        Model.terminalTypeList = resp.reportTerminalTypeList;
                        Model.paginationTerminalType.totalCount = resp.total;
                    } else {
                        Model.terminalTypeList = [];
                        Model.paginationTerminalType.totalCount = 0;
                    }

                    getEchartConfig();
                    Model.paginationTerminalType.currentPage = 1;
                    Model.paginationTerminalType.itemsPerPage = Model.paginationTerminalType.itemsPerPageBackUp;
                    pageChangeTerminalTypeDownload();

                }).catch(function () {
                    getEchartConfig();
                    Model.terminalTypeList = [];
                    Model.paginationTerminalType.totalCount = 0;
                })

            };

            //获取地域图形数据
            function getReportRegionaltypeData(appId, startTime,
                                               endTime, pageSize, pageBegin, topId, type, province) {
                endTime = AUI.DateUtil.getEndTime(endTime);

                var params;
                params = {
                    appId: appId,
                    startTime: startTime,
                    endTime: endTime,
                    pageSize: pageSize,
                    pageBegin: pageBegin,
                    topId: topId,
                    type: type,
                    province: province
                };
                OpenOther.getRegionalRreportListBI(params).then(function (resp) {
                    // 用户访问记录需求
                    //当返回参数为正常的是的
                    if (parseInt(resp.returnCode, 10) === 200 || parseInt(resp.returnCode, 10) === 100) {
                        Model.regionnalList = resp.regionalReportList;
                        Model.paginationRegionnal.totalCount = resp.total;
                    } else {
                        Model.regionnalList = [];
                        Model.paginationRegionnal.totalCount = 0;
                    }
                    getEchartConfig();
                    Model.paginationRegionnal.currentPage = 1;
                    Model.paginationRegionnal.itemsPerPage = Model.paginationRegionnal.itemsPerPageBackUp;
                    pageChangeRegionalDownload();

                }).catch(function () {
                    getEchartConfig();
                    Model.regionnalList = [];
                    Model.paginationRegionnal.totalCount = 0;
                })

            };

            function downloadDownloadList() {

                switch (Model.tabType) {
                    case 'install':
                        downLoadSurveyReport();
                        break;
                    case 'activation':
                        downLoadSurveyReport();
                        break;
                    case 'active':
                        downLoadSurveyReport();
                        break;
                    case 'activate':
                        downLoadActivateReport();
                        break;
                    case 'regionnal':
                        downLoadReportregionnal();
                        break;
                    case 'terminalType':
                        downLoadReportTerminalType();
                        break;
                    case 'version':
                        downLoadReportVersion();
                        break;
                    case 'portrait':
                        downLoadReportPortrait();
                        break;
                }
            }

            function downLoadReportPortrait() {
                var appId = Model.queryPortrait.appId;
                var startTime = Model.queryPortrait.startTime;
                var endTime = Model.queryPortrait.endTime;

                if (startTime === "" || endTime === "") {
                    auiDialog.fail('请选择正确的时间。');
                    return;
                }
                var params = {};
                params.startTime = startTime;
                params.endTime = endTime;
                params.endTime = AUI.DateUtil.getEndTime(params.endTime);
                params.appId = appId;

                if (!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReportAppPortraitBI, params, function (resp) {
                    return resp && resp.downUrl;
                });

            }

            function downLoadReportVersion() {

                var startTime = Model.queryVersion.startTime;
                var endTime = Model.queryVersion.endTime;

                var params = {};
                var appId = Model.queryVersion.appId;
                if (appId == -1) {
                    auiDialog.fail('请选择单个应用进行查询下载。');
                    return;
                }
                var paramsTemp = getParamsVersion();
                if (parseInt(appId, 10) === -1) {
                    params = paramsTemp;
                    params.appId = '-1';
                }
                else {
                    params = paramsTemp;
                    params.appId = appId;
                }

                if (!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }

                $scope.$parent.downloadReport(OpenOther.exportReportAppVersionBI, params, function (resp) {
                    return resp && resp.downUrl;
                });

            }

            function downLoadReportTerminalType() {

                var startTime = Model.queryTerminalType.startTime;
                var endTime = Model.queryTerminalType.endTime;

                if (startTime === "" || endTime === "") {
                    auiDialog.fail('请选择正确的时间。');
                    return;
                }
                var params = {};
                params.startTime = startTime;
                params.endTime = endTime;
                params.endTime = AUI.DateUtil.getEndTime(params.endTime);
                if (Model.queryTerminalType.appId !== -1) {
                    params.appId = Model.queryTerminalType.appId;
                }
                var appId = (Model.queryTerminalType.appId.toString() !== "-1") ? Model.queryTerminalType.appId : -1;
                params.appId = appId;
                params.topTerminalType = Model.queryTerminalType.topTerminalTop;
                params.sortType = Model.queryTerminalType.topTerminalSortType;
                var os = Model.queryTerminalType.os;

                if (os instanceof Array && os.length > 0) {
                    var osStr = '';
                    os.forEach(function (v) {
                        osStr += v.os + ',';
                    });
                    os = osStr.substring(0, osStr.length - 1);
                } else {
                    os = '0';
                }

                params.os = os;

                if (!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }

                $scope.$parent.downloadReport(OpenOther.exportReportTerminaltypeBI, params, function (resp) {
                    return resp && resp.downUrl;
                });
            };
            function downLoadReportregionnal() {

                var startTime = Model.queryRegionnal.startTime;
                var endTime = Model.queryRegionnal.endTime;

                if (startTime === "" || endTime === "") {
                    auiDialog.fail('请选择正确的时间。');
                    return;
                }
                var params = {};
                params.startTime = startTime;
                params.endTime = AUI.DateUtil.getEndTime(endTime);
                if (Model.queryRegionnal.appId !== -1) {
                    params.appId = Model.queryRegionnal.appId;
                }
                var appId = (Model.queryRegionnal.appId.toString() !== "-1") ? Model.queryRegionnal.appId
                    : -1;
                params.appId = appId;
                params.topId = Model.queryRegionnal.RegionnalTop;
                params.type = Model.queryRegionnal.RegionnalSortType;
                var province = Model.queryRegionnal.province;
                province = $.trim(province);
                var reg = /^[\u4e00-\u9fa5]+$/;

                if (province && !reg.test(province)) {
                    auiDialog.fail('请输入正确的地域。');
                    return;
                }
                params.province = province;

                if (!$scope.$parent.checkDate(params)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReportRegionalBI, params, function (resp) {
                    return resp && resp.downUrl;
                });

            };

            ///* 5. 函数声明 */
            function downLoadSurveyReport() {
                var type = '1';
                var appId = '-1';
                var startTime, endTime;
                var queryList = {};
                if (Model.tabType == 'install') {
                    appId = Model.queryInstall.appId;
                    startTime = Model.queryInstall.startTime;
                    endTime = Model.queryInstall.endTime;
                    type = '1';
                    if (Model.installList != null) {
                        queryList = Model.installList.reportAppDayList;
                    }
                } else if (Model.tabType == 'activation') {
                    appId = Model.queryActivation.appId;
                    startTime = Model.queryActivation.startTime;
                    endTime = Model.queryActivation.endTime;
                    type = '2';
                    if (Model.activationList != null) {
                        queryList = Model.activationList.reportAppDayList;
                    }
                } else if (Model.tabType == 'active') {
                    appId = Model.queryActive.appId;
                    startTime = Model.queryActive.startTime;
                    endTime = Model.queryActive.endTime;
                    type = '3';
                    if (Model.activeList != null) {
                        queryList = Model.activeList.reportAppDayList;
                    }
                }
                var request = {
                    type: type,
                    appId: appId,
                    startTime: startTime,
                    endTime: endTime
                };
                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.exportReportAppDayBI, request, function (resp) {
                    return resp && resp.retCode == 200;
                });

            }

            function downLoadActivateReport() {
                if (Model.activateList == null) {
                    Model.activateList = {};
                }
                var request = {
                    appId: Model.queryActivate.appId,
                    startTime: Model.queryActivate.startTime,
                    endTime: Model.queryActivate.endTime,
                    pageSize: Model.paginationActivate.itemsPerPage,
                    pageNum: Model.paginationActivate.currentPage
                };

                if (!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误", "查询时间不得为空");
                    return;
                }

                $scope.$parent.downloadReport(OpenOther.exportReportAppActivateBI, request, function (resp) {

                    return resp && resp.downUrl;
                });

            }

            function installContentChange() {
                if (Model.installList && Model.installList.reportAppDayList.length > 0) {
                    var showItem = [Model.queryInstall.installContentSum, Model.queryInstall.installContentDay, Model.queryInstall.installContentNew, Model.queryInstall.installContentUpdate];
                    var result = reportUtil.getXYFromBI(Model.installList.reportAppDayList, "dateTime", 1,
                        ["appInstallNumDayTotal", "updateDay", "installTotalDay", "installTotal"]);
                    Model.installCharts.options = result && result.dateTime && result.dateTime.length > 0 ? AppSurveyReport.initInstallConf(result, showItem, Model.installMagicType) : null;
                } else {
                    Model.installCharts.options = null;
                }
            }

            function activationContentChange() {
                if (Model.activationList && Model.activationList.reportAppDayList.length > 0) {
                    var showItem = [Model.queryActivation.activationContentNew, Model.queryActivation.activationContentSum];
                    var result = reportUtil.getXYFromBI(Model.activationList.reportAppDayList, "dateTime", 1,
                        ["activationDay", "activationTotal"]);
                    Model.activationCharts.options = result && result.dateTime && result.dateTime.length > 0 ? AppSurveyReport.initActivationConf(result, showItem, Model.activationMagicType) : null;
                } else {
                    Model.activationCharts.options = null;
                }
            }


            function queryInstallList() {
                if (Model.queryInstall.installContentSum == -1 && Model.queryInstall.installContentDay == -1 && Model.queryInstall.installContentNew == -1 && Model.queryInstall.installContentUpdate == -1) {
                    auiDialog.fail('请至少选择一个查看内容。');
                    return false;
                }
                if (Model.installList == null) {
                    Model.installList = {};
                }
                Model.paginationInstall.currentPage = 1;
                Model.paginationInstall.itemsPerPage = Model.paginationInstall.itemsPerPageBackUp;
                var request = {
                    type: "1",
                    appId: Model.queryInstall.appId,
                    startTime: Model.queryInstall.startTime,
                    endTime: Model.queryInstall.endTime,
                    pageSize: 99,
                    pageNum: 1
                };
                var dateQuery = AppSurveyReport.getQuerySumDate();
                OpenOther.getReportAppDayBI(request).then(function (resp) {
                    if (resp && resp.returnCode == 200) {
                        Model.installList.reportAppDayList = resp.reportAppDayList;
                    } else {
                        Model.installList.reportAppDayList = [];
                    }

                }).catch(function (data) {
                    Model.installList.reportAppDayList = [];
                }).finally(function () {
                    var showItem = [Model.queryInstall.installContentSum, Model.queryInstall.installContentDay, Model.queryInstall.installContentNew, Model.queryInstall.installContentUpdate];
                    var result = reportUtil.getXYFromBI(Model.installList.reportAppDayList, "dateTime", 1,
                        ["appInstallNumDayTotal", "updateDay", "installTotalDay", "installTotal"]);
                    Model.installCharts.options = result && result.dateTime && result.dateTime.length > 0 ? AppSurveyReport.initInstallConf(result, showItem, Model.installMagicType) : null;
                    Model.paginationInstall.totalCount = Model.installList.reportAppDayList.length;
                    pageChangeInstall();
                });

                request.type = "0";
                request.startTime = dateQuery.startDate;
                request.endTime = dateQuery.endDate;
                OpenOther.getReportAppDayBI(request).then(function (resp) {
                    if (resp && resp.returnCode == 200) {
                        var retData = resp.reportAppDayList;
                        var growthRate = '--';
                        if (retData.length > 1) {
                            //
                            growthRate = AppSurveyReport.ration(retData[0].installTotalDay - retData[1].installTotalDay
                                , retData[1].installTotalDay, 2, true);
                            Model.installList.summeryData = {
                                yesterday: retData[0].installTotalDay,
                                beforeYesterday: retData[1].installTotalDay,
                                growthRate: growthRate
                            };

                        } else if (retData.length > 0) {
                            Model.installList.summeryData = {
                                yesterday: retData[0].installTotalDay,
                                beforeYesterday: retData[0].installTotalDay,
                                growthRate: growthRate
                            };
                        }
                    }
                }).catch();
            }

            function queryActivationList() {
                if (Model.queryActivation.activationContentSum == -1 && Model.queryActivation.activationContentNew == -1) {
                    auiDialog.fail('请至少选择一个查看内容。');
                    return false;
                }
                if (Model.activationList == null) {
                    Model.activationList = {};
                }
                Model.paginationActivation.currentPage = 1;
                Model.paginationActivation.itemsPerPage = Model.paginationActivation.itemsPerPageBackUp;
                var request = {
                    type: "2",
                    appId: Model.queryActivation.appId,
                    startTime: Model.queryActivation.startTime,
                    endTime: Model.queryActivation.endTime,
                    pageSize: 99,
                    pageNum: 1
                };
                OpenOther.getReportAppDayBI(request).then(function (resp) {
                    if (resp && resp.returnCode == 200) {
                        Model.activationList.reportAppDayList = resp.reportAppDayList;
                    } else {
                        Model.activationList.reportAppDayList = [];
                    }
                }).catch(function () {
                    Model.activationList.reportAppDayList = [];
                }).finally(function () {
                    var showItem = [Model.queryActivation.activationContentNew, Model.queryActivation.activationContentSum];
                    Model.paginationActivation.totalCount = Model.activationList.reportAppDayList.length;
                    var result = reportUtil.getXYFromBI(Model.activationList.reportAppDayList, "dateTime", 1,
                        ["activationDay", "activationTotal"]);

                    Model.activationCharts.options = result && result.dateTime && result.dateTime.length > 0 ? AppSurveyReport.initActivationConf(result, showItem, Model.activationMagicType) : null;
                    pageChangeActivation();
                });

                var dateQuery = AppSurveyReport.getQuerySumDate();
                request.type = "0";
                request.startTime = dateQuery.startDate;
                request.endTime = dateQuery.endDate;
                OpenOther.getReportAppDayBI(request).then(function (resp) {
                    if (resp && resp.returnCode == 200) {
                        var retData = resp.reportAppDayList;
                        var growthRate = '--';
                        if (retData.length > 1) {
                            //
                            growthRate = AppSurveyReport.ration(retData[0].activationDay - retData[1].activationDay
                                , retData[1].activationDay, 2, true);
                            Model.activationList.summeryData = {
                                yesterday: retData[0].activationDay,
                                beforeYesterday: retData[1].activationDay,
                                growthRate: growthRate
                            };

                        } else if (retData.length > 0) {
                            Model.activationList.summeryData = {
                                yesterday: retData[0].activationDay,
                                beforeYesterday: retData[0].activationDay,
                                growthRate: growthRate
                            };
                        }
                    }
                }).catch();
            }

            function queryActiveList() {
                if (Model.activeList == null) {
                    Model.activeList = {};
                }
                Model.paginationActive.currentPage = 1;
                Model.paginationActive.itemsPerPage = Model.paginationActive.itemsPerPageBackUp;
                var request = {
                    type: "3",
                    appId: Model.queryActive.appId,
                    startTime: Model.queryActive.startTime,
                    endTime: Model.queryActive.endTime,
                    pageSize: 99,
                    pageNum: 1
                };
                OpenOther.getReportAppDayBI(request).then(function (resp) {
                    if (resp && resp.returnCode == 200) {
                        Model.activeList.reportAppDayList = resp.reportAppDayList;
                    } else {
                        Model.activeList.reportAppDayList = [];
                    }
                }).catch(function () {
                    Model.activeList.reportAppDayList = [];
                }).finally(function () {
                    Model.paginationActive.totalCount = Model.activeList.reportAppDayList.length;
                    var result = reportUtil.getXYFromBI(Model.activeList.reportAppDayList, "dateTime", 1,
                        ["activeDay"]);

                    Model.activeCharts.options = result && result.dateTime && result.dateTime.length > 0 ? AppSurveyReport.initActiveConf(result, null, Model.activeMagicType) : null;
                    pageChangeActive();
                });

                var dateQuery = AppSurveyReport.getQuerySumDate();
                request.startTime = dateQuery.startDate;
                request.endTime = dateQuery.endDate;
                request.type = "0";
                OpenOther.getReportAppDayBI(request).then(function (resp) {
                    if (resp && resp.returnCode == 200) {
                        var retData = resp.reportAppDayList;
                        var growthRate = '--';
                        if (retData.length > 1) {
                            //
                            growthRate = AppSurveyReport.ration(retData[0].activeDay - retData[1].activeDay
                                , retData[1].activeDay, 2, true);
                            Model.activeList.summeryData = {
                                yesterday: retData[0].activeDay,
                                beforeYesterday: retData[1].activeDay,
                                growthRate: growthRate
                            };

                        } else if (retData.length > 0) {
                            Model.activeList.summeryData = {
                                yesterday: retData[0].activeDay,
                                beforeYesterday: retData[0].activeDay,
                                growthRate: growthRate
                            };
                        }

                    }
                }).catch();
            }

            function queryActivateList() {
                if (Model.activateList == null) {
                    Model.activateList = {};
                }
                Model.paginationActivate.currentPage = 1;
                Model.paginationActivate.itemsPerPage = Model.paginationActivate.itemsPerPageBackUp;
                var request = {
                    appId: Model.queryActivate.appId,
                    startTime: Model.queryActivate.startTime,
                    endTime: Model.queryActivate.endTime,
                    pageSize: 99,
                    pageNum: 1
                };
                OpenOther.getReportAppActivateBI(request).then(function (resp) {
                    if (resp && resp.retCode == 200) {
                        Model.activateList.reportAppActivateTableList = AppSurveyReport.getXAxis(resp.reportAppActivateTableList, 'weekTime');
                    } else {
                        Model.activateList.reportAppActivateTableList = [];
                    }
                }).catch(function () {
                    Model.activateList.reportAppActivateTableList = [];
                }).finally(function () {
                    Model.paginationActivate.totalCount = Model.activateList.reportAppActivateTableList.length;
                    var result = reportUtil.getXYFromBI(Model.activateList.reportAppActivateTableList, "dateTime", 1,
                        ["type5", "type4", "type3", "type2", "type1"]);
                    Model.activateCharts.options = result && result.dateTime && result.dateTime.length > 0 ? AppSurveyReport.initActivateConf(result, null, Model.activateMagicType) : null;
                    pageChangeActivate();
                });

            }

            function initRegionnal() {
                var yLabeltitle = "单位(次)";
                var max = 1000;
                var data = Model.regionnalList;
                var lineArr = [];
                var line0 = [];
                var line1 = [];
                var line2 = [];
                if (data && data.length > 0) {
                    //判断最大值
                    max = 0;
                    for (var i = 0; i < data.length - 1; i++) {
                        var rad = data[i];
                        if (max < parseFloat(rad.install)) {
                            max = parseFloat(rad.install);
                        }
                        if (max < parseFloat(rad.activation)) {
                            max = parseFloat(rad.activation);
                        }
                    }
                    //个位
                    if (max < 1000000) {
                        yLabeltitle = "单位(次)"
                        for (var i = 0; i < data.length - 1; i++) {

                            var rad = data[i];
                            line0.push(rad.province);

                            rad.install = rad.install ? rad.install : 0;
                            line1.push(parseInt(rad.install, 10));

                            rad.activation = rad.activation ? rad.activation : 0;
                            line2.push(parseInt(rad.activation, 10));
                        }
                        //万
                    } else if (max < 10000000000) {
                        yLabeltitle = "单位(万次)"
                        for (var i = 0; i < data.length - 1; i++) {

                            var rad = data[i];
                            line0.push(rad.province);

                            rad.install = rad.install ? rad.install : 0;
                            line1.push(parseInt(rad.install, 10) / 10000);

                            rad.activation = rad.activation ? rad.activation : 0;
                            line2.push(parseInt(rad.activation, 10) / 10000);
                        }
                        //亿
                    } else {
                        yLabeltitle = "单位(亿次)"
                        for (var i = 0; i < data.length - 1; i++) {

                            var rad = data[i];
                            line0.push(rad.province);

                            rad.install = rad.install ? rad.install : 0;
                            line1.push(parseInt(rad.install, 10) / 100000000);

                            rad.activation = rad.activation ? rad.activation : 0;
                            line2.push(parseInt(rad.activation, 10) / 100000000);
                        }
                    }

                    lineArr = [line0, line1, line2];
                    var yAxis =  [{name: yLabeltitle, type: 'value'}];
                    var xAxis =  [{type: 'category', data: lineArr[0]}];

                    if (Model.queryRegionnal.watchContentAll == 1) {
                        if (Model.queryRegionnal.RegionnalSortType == 1) {
                            Model.downloadRegionnalCharts.options = {
                                legend: {
                                    data: ['安装量', '激活量']
                                },
                                series: [{
                                    "name": "安装量",
                                    "type": Model.regionnalMagicType,
                                    "data": lineArr[1]
                                }, {
                                    "name": "激活量",
                                    "type": Model.regionnalMagicType,
                                    "data": lineArr[2]
                                }]
                            }
                            Model.downloadRegionnalCharts.options.xAxis = xAxis;
                            Model.downloadRegionnalCharts.options.yAxis = yAxis;
                        } else {
                            Model.downloadRegionnalCharts.options = {
                                legend: {
                                    data: ['激活量', '安装量']
                                },
                                series: [

                                    {
                                        "name": "激活量",
                                        "type": Model.regionnalMagicType,
                                        "data": lineArr[2]
                                    }, {
                                        "name": "安装量",
                                        "type": Model.regionnalMagicType,
                                        "data": lineArr[1]
                                    }]
                            }
                            Model.downloadRegionnalCharts.options.xAxis = xAxis;
                            Model.downloadRegionnalCharts.options.yAxis = yAxis;
                        }

                    } else if (Model.queryRegionnal.watchContentInstall == 11) {

                        Model.downloadRegionnalCharts.options = {
                            legend: {
                                data: ['安装量']
                            },
                            series: [{
                                "name": "安装量",
                                "type": Model.regionnalMagicType,
                                "data": lineArr[1]
                            }]
                        }
                        Model.downloadRegionnalCharts.options.xAxis = xAxis;
                        Model.downloadRegionnalCharts.options.yAxis = yAxis;

                    } else if (Model.queryRegionnal.watchContentActivation == 12) {

                        Model.downloadRegionnalCharts.options = {
                            legend: {
                                data: ['激活量']
                            },
                            series: [

                                {
                                    "name": "激活量",
                                    "type": Model.regionnalMagicType,
                                    "data": lineArr[2]
                                }]
                        }
                        Model.downloadRegionnalCharts.options.xAxis = xAxis;
                        Model.downloadRegionnalCharts.options.yAxis = yAxis;
                    }

                } else {
                    Model.downloadRegionnalCharts.options = null;
                }
            }

            function initTerminalType() {
                var lineArr = [];
                var line0 = [];
                var line1 = [];
                var line2 = [];
                var max = 1000;
                var yLabeltitle = "单位(次)";
                var data = Model.terminalTypeList;
                if (data && data.length > 0) {
                    //判断最大值
                    max = 0;
                    for (var i = 0; i < data.length - 1; i++) {
                        var rad = data[i];
                        if (max < parseFloat(rad.increasedDay)) {
                            max = parseFloat(rad.increasedDay);
                        }
                        if (max < parseFloat(rad.activationDay)) {
                            max = parseFloat(rad.activationDay);
                        }
                    }
                    //个位
                    if (max < 1000000) {
                        yLabeltitle = "单位(次)"
                        for (var i = 0; i < data.length - 1; i++) {

                            var rad = data[i];
                            line0.push(rad.terminalType);

                            rad.increasedDay = rad.increasedDay ? rad.increasedDay : 0;
                            line1.push(parseInt(rad.increasedDay, 10));

                            rad.activationDay = rad.activationDay ? rad.activationDay : 0;
                            line2.push(parseInt(rad.activationDay, 10));
                        }
                        //万
                    } else if (max < 10000000000) {
                        yLabeltitle = "单位(万次)"
                        for (var i = 0; i < data.length - 1; i++) {

                            var rad = data[i];
                            line0.push(rad.terminalType);

                            rad.increasedDay = rad.increasedDay ? rad.increasedDay : 0;
                            line1.push(parseInt(rad.increasedDay, 10) / 10000);

                            rad.activationDay = rad.activationDay ? rad.activationDay : 0;
                            line2.push(parseInt(rad.activationDay, 10) / 10000);
                        }
                        //亿
                    } else {
                        yLabeltitle = "单位(亿次)"
                        for (var i = 0; i < data.length - 1; i++) {

                            var rad = data[i];
                            line0.push(rad.terminalType);

                            rad.increasedDay = rad.increasedDay ? rad.increasedDay : 0;
                            line1.push(parseInt(rad.increasedDay, 10) / 100000000);

                            rad.activationDay = rad.activationDay ? rad.activationDay : 0;
                            line2.push(parseInt(rad.activationDay, 10) / 100000000);
                        }
                    }


                    lineArr = [line0, line1, line2];
                    var xAxis =  [{ // 横坐标
                        type: 'category', data: lineArr[0]
                    }];
                    var yAxis =  [{ // 纵坐标
                        name: yLabeltitle,
                        type: 'value'
                    }];
                    if (Model.queryTerminalType.watchContentAll == 1) {
                        if (Model.queryTerminalType.topTerminalSortType == 'increasedDay') {
                            Model.downloadTerminalTypeCharts.options = {
                                legend: {
                                    data: ['安装量', '激活量']
                                },
                                series: [{
                                    "name": "安装量",
                                    "type": Model.terminalTypeMagicType,
                                    "data": lineArr[1]
                                }, {
                                    "name": "激活量",
                                    "type": Model.terminalTypeMagicType,
                                    "data": lineArr[2]
                                }]
                            }
                            Model.downloadTerminalTypeCharts.options.xAxis = xAxis;
                            Model.downloadTerminalTypeCharts.options.yAxis = yAxis;
                        } else {
                            Model.downloadTerminalTypeCharts.options = {
                                legend: {
                                    data: ['激活量', '安装量']
                                },
                                series: [
                                    {
                                        "name": "激活量",
                                        "type": Model.terminalTypeMagicType,
                                        "data": lineArr[2]
                                    }, {
                                        "name": "安装量",
                                        "type": Model.terminalTypeMagicType,
                                        "data": lineArr[1]
                                    }]
                            }
                            Model.downloadTerminalTypeCharts.options.xAxis = xAxis;
                            Model.downloadTerminalTypeCharts.options.yAxis = yAxis;
                        }
                    } else if (Model.queryTerminalType.watchContentInstall == 11) {
                        Model.downloadTerminalTypeCharts.options = {
                            legend: {
                                data: ['安装量']
                            },
                            series: [{
                                "name": "安装量",
                                "type": Model.terminalTypeMagicType,
                                "data": lineArr[1]
                            }]
                        }
                    } else if (Model.queryTerminalType.watchContentActivation == 12) {
                        Model.downloadTerminalTypeCharts.options = {
                            legend: {
                                data: ['激活量']
                            },
                            series: [
                                {
                                    "name": "激活量",
                                    "type": Model.terminalTypeMagicType,
                                    "data": lineArr[2]
                                }]
                        }
                        Model.downloadTerminalTypeCharts.options.xAxis = xAxis;
                        Model.downloadTerminalTypeCharts.options.yAxis = yAxis;
                    }


                } else {
                    Model.downloadTerminalTypeCharts.options = null;
                }

            }

            function getEchartConfig() {

                switch (Model.tabType) {

                    case 'regionnal':

                        initRegionnal();
                        break;
                    case 'terminalType':

                        initTerminalType();

                        break;
                    case 'version':

                        initVersion();

                        break;
                    case 'portrait':

                        initPortrait();

                        break;
                }
            }

            function initDownloadPortraitInstallSexCharts(chart4, showLabel_age, showLabel_gender) {
                Model.downloadPortraitInstallSexCharts.options = {
                    legend: {
                        data: showLabel_age
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: showLabel_gender
                    }],
                    yAxis: [{ // 纵坐标
                        name: '安装用户画像分析——性别',
                        type: 'value'
                    }],
                    series: [
                        {
                            "name": "<18",
                            "type": Model.portraitMagicType1,
                            "data": chart4[0]
                        },
                        {
                            "name": "19-24",
                            "type": Model.portraitMagicType1,
                            "data": chart4[1]
                        },
                        {
                            "name": "25-29",
                            "type": Model.portraitMagicType1,
                            "data": chart4[2]
                        },
                        {
                            "name": "30-34",
                            "type": Model.portraitMagicType1,
                            "data": chart4[3]
                        },
                        {
                            "name": "35-39",
                            "type": Model.portraitMagicType1,
                            "data": chart4[4]
                        },
                        {
                            "name": "40-44",
                            "type": Model.portraitMagicType1,
                            "data": chart4[5]
                        },
                        {
                            "name": "45-49",
                            "type": Model.portraitMagicType1,
                            "data": chart4[6]
                        },
                        {
                            "name": ">50",
                            "type": Model.portraitMagicType1,
                            "data": chart4[7]
                        },
                        {
                            "name": "未知",
                            "type": Model.portraitMagicType1,
                            "data": chart4[8]
                        }]
                }
            }

            function initDownloadPortraitActivationSexCharts(chart5, showLabel_age, showLabel_gender) {

                Model.downloadPortraitActivationSexCharts.options = {
                    legend: {
                        data: showLabel_age
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: showLabel_gender
                    }],
                    yAxis: [{ // 纵坐标
                        name: '激活用户画像分析——性别',
                        type: 'value'
                    }],
                    series: [
                        {
                            "name": "<18",
                            "type": Model.portraitMagicType2,
                            "data": chart5[0]
                        },
                        {
                            "name": "19-24",
                            "type": Model.portraitMagicType2,
                            "data": chart5[1]
                        },
                        {
                            "name": "25-29",
                            "type": Model.portraitMagicType2,
                            "data": chart5[2]
                        },
                        {
                            "name": "30-34",
                            "type": Model.portraitMagicType2,
                            "data": chart5[3]
                        },
                        {
                            "name": "35-39",
                            "type": Model.portraitMagicType2,
                            "data": chart5[4]
                        },
                        {
                            "name": "40-44",
                            "type": Model.portraitMagicType2,
                            "data": chart5[5]
                        },
                        {
                            "name": "45-49",
                            "type": Model.portraitMagicType2,
                            "data": chart5[6]
                        },
                        {
                            "name": ">50",
                            "type": Model.portraitMagicType2,
                            "data": chart5[7]
                        },
                        {
                            "name": "未知",
                            "type": Model.portraitMagicType2,
                            "data": chart5[8]
                        }]
                }
            }

            function initDownloadPortraitInstallAgeCharts(chart1, showLabel_age, showLabel_gender) {
                Model.downloadPortraitInstallAgeCharts.options = {
                    legend: {
                        data: showLabel_gender
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: showLabel_age
                    }],
                    yAxis: [{ // 纵坐标
                        name: '安装用户画像分析--年龄段',
                        type: 'value'
                    }],
                    series: [
                        {
                            "name": "男性",
                            "type": Model.portraitMagicType3,
                            "data": chart1[0]
                        },
                        {
                            "name": "女性",
                            "type": Model.portraitMagicType3,
                            "data": chart1[1]
                        },
                        {
                            "name": "未知",
                            "type": Model.portraitMagicType3,
                            "data": chart1[2]
                        }]
                }
            }

            function initDownloadPortraitActivationAgeCharts(chart2, showLabel_age, showLabel_gender) {
                Model.downloadPortraitActivationAgeCharts.options = {
                    legend: {
                        data: showLabel_gender
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: showLabel_age
                    }],
                    yAxis: [{ // 纵坐标
                        name: '激活用户画像分析--年龄段',
                        type: 'value'
                    }],
                    series: [
                        {
                            "name": "男性",
                            "type": Model.portraitMagicType4,
                            "data": chart2[0]
                        },
                        {
                            "name": "女性",
                            "type": Model.portraitMagicType4,
                            "data": chart2[1]
                        },
                        {
                            "name": "未知",
                            "type": Model.portraitMagicType4,
                            "data": chart2[2]
                        }]
                }
            }

            function initPortrait() {

                var linePoint = [];
                var chart1 = [];
                var chart2 = [];
                var chart4 = [];
                var chart5 = [];
                var showLabel_age = ["<18", "19-24", "25-29", "30-34", "35-39", "40-44", "45-49", ">50", "未知"];
                var showLabel_gender = ["男性", "女性", "未知"];


                if (Model.portraitList && Model.portraitList.length > 0) {
                    //安装用户画像分析——年龄段
                    //男性用户
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age18, 10));
                    linePoint.push(parseFloat(Model.portraitList[0].age24, 10));
                    linePoint.push(parseFloat(Model.portraitList[0].age29, 10));
                    linePoint.push(parseFloat(Model.portraitList[0].age34, 10));
                    linePoint.push(parseFloat(Model.portraitList[0].age39, 10));
                    linePoint.push(parseFloat(Model.portraitList[0].age44, 10));
                    linePoint.push(parseFloat(Model.portraitList[0].age49, 10));
                    linePoint.push(parseFloat(Model.portraitList[0].age50, 10));
                    linePoint.push(0);
                    chart1.push(linePoint);
                    //女性用户
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[1].age18, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age24, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age29, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age34, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age39, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age44, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age49, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age50, 10));
                    linePoint.push(0);
                    chart1.push(linePoint);
                    //未知用户
                    linePoint = [];
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(parseFloat(Model.portraitList[0].agex, 10));
                    chart1.push(linePoint);
                    //激活用户画像分析——年龄段
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age18, 10));
                    linePoint.push(parseFloat(Model.portraitList[2].age24, 10));
                    linePoint.push(parseFloat(Model.portraitList[2].age29, 10));
                    linePoint.push(parseFloat(Model.portraitList[2].age34, 10));
                    linePoint.push(parseFloat(Model.portraitList[2].age39, 10));
                    linePoint.push(parseFloat(Model.portraitList[2].age44, 10));
                    linePoint.push(parseFloat(Model.portraitList[2].age49, 10));
                    linePoint.push(parseFloat(Model.portraitList[2].age50, 10));
                    linePoint.push(0);
                    chart2.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[3].age18, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age24, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age29, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age34, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age39, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age44, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age49, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age50, 10));
                    linePoint.push(0);
                    chart2.push(linePoint);
                    //未知用户
                    linePoint = [];
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(parseFloat(Model.portraitList[2].agex, 10));
                    chart2.push(linePoint);

                    //安装用户画像分析——性别
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age18, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age18, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age24, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age24, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age29, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age29, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age34, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age34, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age39, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age39, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age44, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age44, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age49, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age49, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[0].age50, 10));
                    linePoint.push(parseFloat(Model.portraitList[1].age50, 10));
                    linePoint.push(0);
                    chart4.push(linePoint);
                    linePoint = [];
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(parseFloat(Model.portraitList[0].agex, 10));
                    chart4.push(linePoint);
                    //激活用户画像分析——性别
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age18, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age18, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age24, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age24, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age29, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age29, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age34, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age34, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age39, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age39, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age44, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age44, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age49, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age49, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(parseFloat(Model.portraitList[2].age50, 10));
                    linePoint.push(parseFloat(Model.portraitList[3].age50, 10));
                    linePoint.push(0);
                    chart5.push(linePoint);
                    linePoint = [];
                    linePoint.push(0);
                    linePoint.push(0);
                    linePoint.push(parseFloat(Model.portraitList[2].agex, 10));
                    chart5.push(linePoint);


                    if (Model.queryPortrait.watchContentPortraitAll == 1) {

                        if (Model.queryPortrait.watchContentPeopleAll == 1) {
                            //四张图
                            //安装-性别
                            initDownloadPortraitInstallSexCharts(chart4, showLabel_age, showLabel_gender);

                            //激活-性别
                            initDownloadPortraitActivationSexCharts(chart5, showLabel_age, showLabel_gender);


                            //安装-年龄
                            initDownloadPortraitInstallAgeCharts(chart1, showLabel_age, showLabel_gender);


                            //激活-年龄
                            initDownloadPortraitActivationAgeCharts(chart2, showLabel_age, showLabel_gender);
                            Model.installSex = true;
                            Model.activationSex = true;
                            Model.installAge = true;
                            Model.activationAge = true;

                        } else if (Model.queryPortrait.watchContentPeopleSex == 11) {
                            //两张图  安装-性别  激活性别
                            //安装-性别
                            initDownloadPortraitInstallSexCharts(chart4, showLabel_age, showLabel_gender);
                            //激活-性别
                            initDownloadPortraitActivationSexCharts(chart5, showLabel_age, showLabel_gender);
                            Model.installSex = true;
                            Model.activationSex = true;
                            Model.installAge = false;
                            Model.activationAge = false;


                        } else {
                            //两张图  安装-年龄  激活年龄
                            //安装-年龄
                            initDownloadPortraitInstallAgeCharts(chart1, showLabel_age, showLabel_gender);
                            //激活-年龄
                            initDownloadPortraitActivationAgeCharts(chart2, showLabel_age, showLabel_gender);
                            Model.installSex = false;
                            Model.activationSex = false;
                            Model.installAge = true;
                            Model.activationAge = true;
                        }


                    } else if (Model.queryPortrait.watchContentPortraitInstall == 11) {

                        if (Model.queryPortrait.watchContentPeopleAll == 1) {
                            //二张图 安装-性别  安装年龄
                            //安装-性别
                            initDownloadPortraitInstallSexCharts(chart4, showLabel_age, showLabel_gender);
                            //安装-年龄
                            initDownloadPortraitInstallAgeCharts(chart1, showLabel_age, showLabel_gender);

                            Model.installSex = true;
                            Model.activationSex = false;
                            Model.installAge = true;
                            Model.activationAge = false;
                        } else if (Model.queryPortrait.watchContentPeopleSex == 11) {
                            //一张图  安装-性别
                            //安装-性别
                            initDownloadPortraitInstallSexCharts(chart4, showLabel_age, showLabel_gender);
                            Model.installSex = true;
                            Model.activationSex = false;
                            Model.installAge = false;
                            Model.activationAge = false;

                        } else {
                            //一张图  安装-年龄
                            //安装-年龄
                            initDownloadPortraitInstallAgeCharts(chart1, showLabel_age, showLabel_gender);
                            Model.installSex = false;
                            Model.activationSex = false;
                            Model.installAge = true;
                            Model.activationAge = false;
                        }
                    } else {

                        if (Model.queryPortrait.watchContentPeopleAll == 1) {
                            //二张图 激活-性别  激活-年龄
                            //激活-性别
                            initDownloadPortraitActivationSexCharts(chart5, showLabel_age, showLabel_gender);
                            //激活-年龄
                            initDownloadPortraitActivationAgeCharts(chart2, showLabel_age, showLabel_gender);
                            Model.installSex = false;
                            Model.activationSex = true;
                            Model.installAge = false;
                            Model.activationAge = true;

                        } else if (Model.queryPortrait.watchContentPeopleSex == 11) {
                            //一张图  激活-性别
                            //激活-性别
                            initDownloadPortraitActivationSexCharts(chart5, showLabel_age, showLabel_gender);
                            Model.installSex = false;
                            Model.activationSex = true;
                            Model.installAge = false;
                            Model.activationAge = false;

                        } else {
                            //一张图  激活-年龄
                            //激活-年龄
                            initDownloadPortraitActivationAgeCharts(chart2, showLabel_age, showLabel_gender);
                            Model.installSex = false;
                            Model.activationSex = false;
                            Model.installAge = false;
                            Model.activationAge = true;
                        }

                    }
                } else {
                    //安装-性别
                    Model.downloadPortraitInstallSexCharts.options = null;
                    Model.installSex = true;
                    Model.activationSex = false;
                    Model.installAge = false;
                    Model.activationAge = false;
                }
            }

            function hasVersion(ver, list) {

                for (var i = 0; null != list && list.length > 0 && i < list.length; i++) {
                    var v = list[i];
                    if (ver == v) {
                        return true;
                    }
                }
                return false;
            }

            function getListIndex(val, list) {
                for (var i = 0; null != list && list.length > 0 && i < list.length; i++) {
                    var v = list[i];
                    if (val == v) {
                        return i;
                    }
                }
                return -1;
            }

            function dateCompare7(dateStr1, dateStr2) {
                var rst = false;
                var time1 = new Date(dateStr1.replace(/-/g, "/") + " 00:00:00");
                var time2 = new Date(dateStr2.replace(/-/g, "/") + " 00:00:00");

                if (time1.getTime() < time2.getTime()) {
                    rst = true;
                }
                return rst;
            }

            function initVersion() {
                var resp = Model.versionDate;
                var line = [];
                var verL = [];
                var startTime = Model.queryVersion.startTime;
                var endTime = Model.queryVersion.endTime;
                if (angular.isDate(endTime)) {
                    endTime = AUI.DateUtil.date2Str(endTime);
                }
                var endDStr = endTime.replace(/-/g, "/") + " 00:00:00";
                var today = new Date();
                var todayStr = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                var endD = new Date(endDStr);
                var today1 = new Date(todayStr.replace(/-/g, "/") + " 00:00:00");
                var yLabelTitle = "用户数量(个)";
                var max = 0;
                if (today1.getTime() == endD.getTime()) {
                    var tmpTime = today1.getTime() - 86400000;
                    var yesterday = new Date(tmpTime);
                    endTime = yesterday.getFullYear() + '-' + (yesterday.getMonth() + 1) + '-' + yesterday.getDate();
                }

                if (resp && resp.reportAppVersionChartList && resp.reportAppVersionChartList.length > 0) {
                    var verList = resp.reportAppVersionChartList;
                    var line1 = null;
                    var tmp = 0;
                    //判断最大值
                    for (var i = 0; i < verList.length; i++) {
                        tmp = verList[i].content;
                        if (max < tmp) {
                            max = tmp;
                        }
                    }
                    //个位 保留到个了  等产品确认后删除报表
                    if (max < 10000000000) {
                        yLabelTitle = "用户数量(个)";
                        for (var i = 0; i < verList.length; i++) {
                            var ver = verList[i];
                            var linePoint = [];
                            var dt = ver.dateTime;
                            var dateTime = '';
                            if (dt && dt.length == 8) {
                                dateTime = dt.substr(0, 4) + '-' + dt.substr(4, 2) + '-' + dt.substr(6, 2);
                            }
                            else {
                                dateTime = dt;
                            }
                            linePoint.push(dateTime);
                            var has = hasVersion(ver.version, verL);
                            if (has == false || line1 == null) {
                                if (verL.length > 0) {
                                    //-- 还原成原来的显示方式 start--------
                                    var dt2 = verList[i - 1].dateTime; //the end dateTime of line1
                                    var dateTime2 = ''; // the end dateTime of line1 with the format "yyyy-mm-dd"
                                    if (dt2 && dt2.length == 8) {
                                        dateTime2 = dt2.substr(0, 4) + '-' + dt2.substr(4, 2) + '-' + dt2.substr(6, 2);
                                    }
                                    else {
                                        dateTime2 = dt2;
                                    }
                                    if (i >= 1 && dateCompare7(dateTime2, endTime)) // line1的结束时间<查询条件的结束时间
                                    {
                                        var lineEndPoint = [];
                                        lineEndPoint.push(endTime);
                                        lineEndPoint.push(0);
                                        line1.push(lineEndPoint);
                                    }
                                    //-- 还原成原来的显示方式 end------------
                                    line.push(line1);
                                }
                                verL.push(ver.version);

                                line1 = [];
                                //-- 还原成原来的显示方式 start-------------
                                // 设置初始值
                                if (dateCompare7(startTime, dateTime)) {
                                    var lineStartPoint = [];
                                    lineStartPoint.push(startTime);
                                    lineStartPoint.push(0);
                                    line1.push(lineStartPoint);
                                }
                                //-- 还原成原来的显示方式 end-------------
                            }

                            linePoint.push(parseInt(ver.content, 10));
                            line1.push(linePoint);
                        }

                    }
                    //-- 还原成原来的显示方式start-----------------
                    var dt = verList[verList.length - 1].dateTime;
                    var dateTime = '';
                    if (dt && dt.length == 8) {
                        dateTime = dt.substr(0, 4) + '-' + dt.substr(4, 2) + '-' + dt.substr(6, 2);
                    }
                    else {
                        dateTime = dt;
                    }
                    if (dateCompare7(dateTime, endTime)) {
                        var lineEndPoint = [];
                        lineEndPoint.push(endTime);
                        lineEndPoint.push(0);
                        line1.push(lineEndPoint);
                    }
                    //-- 还原成原来的显示方式end-------------------
                    line.push(line1);
                } else {
                    line = null;
                    verL = ['全部'];
                }
                var tipStr;
                if (Model.queryVersion.versionContent == 2) {
                    //累计安装用户
                    tipStr = '累计安装用户';
                } else if (Model.queryVersion.versionContent == 1) {
                    //日活跃用户
                    tipStr = '日活跃用户';
                } else {
                    //新增安装用户
                    tipStr = '新增安装用户';
                }
                if (line != null) {

                    var xAxisTime = AUI.DateUtil.getTimeAll(startTime, endTime);

                    var seriesParam = [];

                    for (var i = 0; i < verL.length; i++) {

                        var name = verL[i];
                        var data = Array(xAxisTime.length + 1).join(0).split('');

                        for (var j = 0; j < line[i].length; j++) {

                            var tempTime = line[i][j][0];
                            var indx = getListIndex(tempTime, xAxisTime);
                            if (indx != -1) {
                                data[indx] = line[i][j][1];
                            }

                        }


                        var lastContent = 0;
                        if (Model.queryVersion.versionContent == 2) {

                            for (var k = 0; k < data.length; k++) {
                                var tempContent = data[k];
                                if (tempContent == 0) {
                                    data[k] = lastContent;
                                } else {
                                    lastContent = data[k];
                                }
                            }
                        }

                        seriesParam.push({
                            "name": name,
                            "type": Model.versionMagicType,
                            "data": data
                        })
                    }


                    Model.downloadVersionCharts.options = {
                        legend: {
                            data: verL
                        },
                        xAxis: [{ // 横坐标
                            type: 'category', data: xAxisTime

                        }],
                        yAxis: [{ // 纵坐标
                            name: yLabelTitle + "-" + tipStr,
                            type: 'value'
                        }],
                        series: seriesParam

                    };

                } else {
                    Model.downloadVersionCharts.options = null;
                }


            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeInstall() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.installList.reportAppDayList, Model.paginationInstall));
                Model.installListForShow = result.listForShow;
            }

            function pageChangeActivation() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.activationList.reportAppDayList, Model.paginationActivation));
                Model.activationListForShow = result.listForShow;
            }

            function pageChangeActive() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.activeList.reportAppDayList, Model.paginationActive));
                Model.activeListForShow = result.listForShow;
            }

            function pageChangeActivate() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.activateList.reportAppActivateTableList, Model.paginationActivate));
                Model.activateListForShow = result.listForShow;
            }

        }]
    );
});
